export default "__VITE_ASSET__PSJg65qY__"